module.exports = __webpack_public_path__ + "img/couples-067.24d4d2d8.jpg";